import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';

function Login({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const sucesso = location.state?.sucesso || '';
  const [form, setForm] = useState({ email: '', senha: '' });
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const emailRef = useRef(null);
  const senhaRef = useRef(null);
  const [temaDark, setTemaDark] = useState(false);

  useEffect(() => {
    const tema = localStorage.getItem('tema') ||
      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    setTemaDark(tema === 'dark');
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');

    if (!form.email.trim() && !form.senha) {
      setErro('Preencha o e-mail e a senha para continuar.');
      emailRef.current?.focus();
      return;
    }
    if (!form.email.trim()) {
      setErro('Informe seu e-mail.');
      emailRef.current?.focus();
      return;
    }
    if (!form.senha) {
      setErro('Informe sua senha.');
      senhaRef.current?.focus();
      return;
    }

    setCarregando(true);
    try {
      const res = await api.post('/auth/login', form);
      sessionStorage.setItem('token', res.data.token);
      sessionStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      onLogin(res.data.usuario);
    } catch (err) {
      setErro(err.response?.data?.mensagem || 'Erro ao fazer login.');
    }
    setCarregando(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img src="/LogoComNomeDaEmpresa.png" alt="CronoObra" style={{ height: 72, width: 'auto', filter: temaDark ? 'brightness(0) invert(1)' : 'none' }} />
        </div>

        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
            E-mail
          </label>
          <input
            ref={emailRef}
            type="email"
            placeholder="seu@email.com"
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            style={{ marginBottom: 16 }}
            autoFocus
          />

          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
            Senha
          </label>
          <div style={{ position: 'relative', marginBottom: 8 }}>
            <input
              ref={senhaRef}
              type={mostrarSenha ? 'text' : 'password'}
              placeholder="••••••••"
              value={form.senha}
              onChange={e => setForm({ ...form, senha: e.target.value })}
              style={{ marginBottom: 0, paddingRight: 40, width: '100%' }}
            />
            <button
              type="button"
              onClick={() => setMostrarSenha(!mostrarSenha)}
              style={{
                position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', padding: 0,
                color: '#9ca3af', display: 'flex', alignItems: 'center',
              }}
              aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
            >
              {mostrarSenha ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>

          <div style={{ textAlign: 'right', marginBottom: 16 }}>
            <button
              type="button"
              onClick={() => navigate('/esqueci-senha')}
              style={{ background: 'none', border: 'none', color: '#3b82f6', fontSize: 12, cursor: 'pointer', padding: 0 }}
            >
              Esqueci minha senha
            </button>
          </div>

          {sucesso && !erro && (
            <div style={{
              background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8,
              padding: '10px 14px', fontSize: 13, color: '#166534', marginBottom: 16,
            }}>
              {sucesso}
            </div>
          )}

          {erro && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
              padding: '10px 14px', fontSize: 13, color: '#dc2626', marginBottom: 16,
            }}>
              {erro}
            </div>
          )}

          <button
            className="btn-primary"
            type="submit"
            disabled={carregando}
            style={{ width: '100%', marginTop: 8, padding: '12px', fontSize: 15 }}
          >
            {carregando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
